import { type TokenGroup } from "../../types";
import { altitude } from "../globals/altitude";

export const focus = {
  name: "focus",
  variables: {
    ring: {
      type: "color",
      value: {
        dark: altitude.variables["6"].value.dark,
        light: altitude.variables["6"].value.light,
      },
    },
  },
} as const satisfies TokenGroup<"focus">;
